var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.059 5.162c-2.14-1.772-5.324-1.453-7.29.516l-.769.77-.77-.77C9.27 3.71 6.083 3.39 3.943 5.162a5.344 5.344 0 00-.387 7.89l7.559 7.58c.488.49 1.28.49 1.77 0l7.558-7.58a5.341 5.341 0 00-.383-7.89z"
  }))));
}

export default SvgHeart;